

















































































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Emit } from 'vue-property-decorator';
import TalentCollection from '../../../classes/attributes/talentCollection';
import { BeastValue } from '@/interfaces/world/beast';
import firebase from 'firebase/app';
import 'firebase/firebase-functions';

@Component
export default class BeastComponent extends Vue {
  @Prop()
  private id!: string;

  @Prop()
  private name!: string;

  @Prop({ default: '' })
  private description!: string;

  @Prop()
  private type!: string;

  @Prop({ default: null })
  private location!: string | null;

  @Prop()
  private values!: Array<{ name: string; value: number }>;

  @Prop()
  private imageUrl!: string | null;

  @Prop()
  private createdBy!: string;

  @Prop()
  private editAllowed!: string;

  @Prop({ default: false })
  private hideImage!: boolean;

  @Prop({ default: null })
  private classMargins!: Array<number | null> | null;

  private detailView = false;

  private defaultImage = require('@/assets/css/enemies/iconfinder_animal_beast_master_wildlife_bear_paw_druid_3938104.svg');

  private talentCollection = new TalentCollection();

  private beastProcessing = false;
  private showSnackbar = false;
  private snackbarText = '';
  private snackbarColor = '';
  private unlockingIndex: number | null = null;

  get additionalInfo() {
    if (this.location !== null && this.location !== '') {
      return ' | ' + this.location;
    }
    return '';
  }

  get hasMargins() {
    return Array.isArray(this.classMargins) && this.classMargins.filter((margin) => margin !== null).length > 0;
  }

  get marginInfo() {
    if (!Array.isArray(this.classMargins)) {
      return '-';
    }
    return this.classMargins.map((margin) => (margin === null || margin.toString() === '' ? '-' : margin)).join(' / ');
  }

  private getTalentName(abbreviation: string) {
    return this.talentCollection.getTalentByAbbreviation(abbreviation).name;
  }

  private unlockBeastValue(value: BeastValue, index: number) {
    this.beastProcessing = true;
    this.unlockingIndex = index;
    const unlockCall = firebase
      .app()
      .functions('europe-west1')
      .httpsCallable('unlockBeastValue');
    const beastDataPromise = unlockCall({
      worldSlug: 'vjorngard',
      beastId: this.id,
      groupId: this.$store.getters.currentGroup,
      valueName: value.name,
    });
    beastDataPromise
      .then((result) => {
        if (typeof result.data.success !== 'undefined') {
          if (result.data.success === true) {
            // Success
            const payload = {
              beastId: this.id,
              valueName: value.name,
              value: result.data.return,
            };
            this.$store.commit('setBeastValue', payload);
            this.showSnackbar = true;
            this.snackbarText = 'Freigeschaltet';
            this.snackbarColor = 'success';
          } else {
            this.showSnackbar = true;
            this.snackbarText = 'Kein Charakter hat den notwendigen Wert';
            this.snackbarColor = 'error';
          }
        } else {
          this.showSnackbar = true;
          this.snackbarText = 'Ein Fehler ist aufgetreten';
          this.snackbarColor = 'error';
        }
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.beastProcessing = false;
        this.unlockingIndex = null;
      });
  }

  @Emit()
  private editBeast() {
    return true;
  }

  @Emit()
  private deleteBeast() {
    return true;
  }

  private getImageSrc() {
    return this.hasImage() ? this.imageUrl : this.defaultImage;
  }

  private hasImage() {
    return this.imageUrl !== null && this.hideImage !== true;
  }

  private transfDate(dateString: string) {
    const date = new Date(dateString);
    return (
      date.getDate() +
      '.' +
      date.getMonth() +
      '.' +
      date.getFullYear() +
      ' ' +
      date.getHours() +
      ':' +
      date.getMinutes()
    );
  }
}
